import { useCallback } from 'react';
import type { ResourceBlock } from '@domain/schemas/contract.schema';
import { create } from 'zustand';

interface VariationsTabsState {
  map: Record<string, number>;
  getBlockCurrentVariationIdx: (blockId: string) => number;
  setCurrentVariationIdx: (blockId: string, idx: number) => void;
}

export const useVariationsTabsStore = create<VariationsTabsState>((set, get) => ({
  map: {},
  getBlockCurrentVariationIdx: (blockId) => get().map[blockId] ?? 0,
  setCurrentVariationIdx: (blockId, idx) => set({ map: { ...get().map, [blockId]: idx } }),
}));

export const useSyncVariationInView = () => {
  const setCurrentVariationIdx = useVariationsTabsStore((s) => s.setCurrentVariationIdx);

  return useCallback(
    (block: ResourceBlock) => {
      if (!block.variations?.length) return;
      const idx = block.variations.findIndex((v) => v.id === block.selectedVariationId);
      setCurrentVariationIdx(block.id, Math.max(0, idx));
    },
    [setCurrentVariationIdx],
  );
};
